import React, { useState } from 'react';

const ReachUs = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('ReachUs subscription:', email);
    setEmail('');
  };

  return (
    <section className="py-16 bg-navy-light">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Outfitting Your Team?</h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
        We specialize in bulk scrub orders for healthcare teams, clinics, and organizations. Get in touch to discuss styles, sizes, colors, and pricing for your team.
        </p>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
        Request a Bulk Quote
        </p>
        <form onSubmit={handleSubmit} className="max-w-md mx-auto flex">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 py-3 px-4 rounded-l-md bg-navy text-gray-800 placeholder-gray-400 border border-primary/30 focus:outline-none focus:ring-2 focus:ring-primary"
            required
          />
          <button 
            type="submit"
            className="bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-r-md transition duration-300"
          >
            Contact me!
          </button>
        </form>
      </div>
    </section>
  );
};

export default ReachUs;